import van from "vanjs-core";

// biome-ignore lint/nursery/useExplicitType: annoying to update, rely on automatic typing
export const {
	a,
	article,
	br,
	button,
	canvas,
	div,
	h1,
	h2,
	hr,
	input,
	label,
	li,
	nav,
	option,
	p,
	pre,
	section,
	select,
	span,
	table,
	tbody,
	td,
	th,
	tr,
	ul,
} = van.tags;
